import { Lock } from "lucide-react";
import type { MatchCard, PartyView } from "@hub/shared";
import { Avatar } from "@/ui";
import { partyLabel } from "../lib/cards";
import s from "../network.module.css";

export function PartyBubble({ party, size = 36 }: { party: PartyView; size?: number }) {
  const label = partyLabel(party);
  if (party.hidden) {
    return (
      <span className={s.hiddenAvatar} style={{ width: size, height: size }} title={label} aria-label={label} role="img">
        <Lock size={Math.max(12, size * 0.4)} />
      </span>
    );
  }
  return <Avatar name={party.name} src={party.avatarUrl} size={size} seed={party.userId ?? party.contactId ?? party.name} title={label} />;
}

/** Single or dual avatars as described by card.avatar (the handoff visual: your contact plus the owner who can help). */
export function CardAvatar({ avatar, size = 36 }: { avatar: MatchCard["avatar"]; size?: number }) {
  if (avatar.type === "dual" && avatar.secondary) {
    return (
      <span className={s.dualAvatar} style={{ width: size * 1.55, height: size * 1.1 }}>
        <PartyBubble party={avatar.primary} size={size} />
        <PartyBubble party={avatar.secondary} size={size} />
      </span>
    );
  }
  return <PartyBubble party={avatar.primary} size={size} />;
}
